import { useEffect, useRef } from "react";
import api from "@/lib/api";

/** One held request per open support workspace; events return immediately. */
export const useSupportLive = onChange => {
  const callback = useRef(onChange);
  useEffect(() => { callback.current = onChange; }, [onChange]);

  useEffect(() => {
    let active = true;
    let request;
    let retryTimer;
    let wakeRetry;
    const retry = ms => new Promise(resolve => {
      wakeRetry = resolve;
      retryTimer = window.setTimeout(resolve, ms);
    });

    const listen = async () => {
      let cursor = null;
      let failures = 0;
      while (active) {
        request = new AbortController();
        try {
          const { data } = await api.get("/support/live", {
            params: cursor ? { after: cursor } : {},
            signal: request.signal,
            timeout: 30000,
          });
          if (!active) break;
          cursor = data.cursor;
          failures = 0;
          if (data.ticket_id) callback.current(data);
        } catch (error) {
          if (!active || error?.response?.status === 401 || error?.response?.status === 403) break;
          failures += 1;
          await retry(Math.min(15000, 1000 * 2 ** Math.min(failures - 1, 4)));
        }
      }
    };
    listen();
    return () => {
      active = false;
      request?.abort();
      window.clearTimeout(retryTimer);
      wakeRetry?.();
    };
  }, []);
};